var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorSmartObject6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.004,
    height: 80,
    viewBox: "0 0 80.004 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 80.004,
    height: 80,
    transform: "translate(0 -0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(-269.498 -2802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    transform: "translate(269.498 2802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M22.9,50.536H70.8L77.164,23.48H16.538Zm48.888,2.5H21.914a1.252,1.252,0,0,1-1.22-.962L13.752,22.5a1.247,1.247,0,0,1,1.218-1.538H78.752A1.247,1.247,0,0,1,79.97,22.5L73.008,52.074a1.249,1.249,0,0,1-1.218.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M69.732,61.994H24.064a1.252,1.252,0,0,1-1.22-.962L11.652,13.668H1.25a1.25,1.25,0,0,1,0-2.5H12.638a1.252,1.252,0,0,1,1.22.964L25.052,59.494h44.68a1.25,1.25,0,0,1,0,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M32.006,66.776a5.367,5.367,0,1,0,3.79,1.572,5.362,5.362,0,0,0-3.79-1.572m0,13.224a7.866,7.866,0,1,1,5.558-2.3A7.866,7.866,0,0,1,32.006,80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M61.006,66.776a5.367,5.367,0,1,0,3.79,1.572,5.362,5.362,0,0,0-3.79-1.572m0,13.224a7.866,7.866,0,1,1,5.558-2.3A7.866,7.866,0,0,1,61.006,80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M58.288,19.118a1.25,1.25,0,0,1-1.25-1.25V13.7H26.632v4.17a1.25,1.25,0,1,1-2.5,0v-5.42a1.25,1.25,0,0,1,1.25-1.25H58.288a1.25,1.25,0,0,1,1.25,1.25v5.42a1.25,1.25,0,0,1-1.25,1.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M70.82,19.118a1.25,1.25,0,0,1-1.25-1.25V2.5H46.658V7.95a1.25,1.25,0,1,1-2.5,0V1.25A1.249,1.249,0,0,1,45.408,0H70.826a1.25,1.25,0,0,1,1.25,1.25V17.868a1.25,1.25,0,0,1-1.256,1.25"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M330.388,2882a7.861,7.861,0,1,1,.227,0Zm-3.676-11.654a5.36,5.36,0,1,0,3.792-1.57A5.363,5.363,0,0,0,326.713,2870.346ZM301.388,2882a7.861,7.861,0,1,1,.227,0Zm-3.676-11.654a5.359,5.359,0,1,0,3.792-1.57A5.364,5.364,0,0,0,297.713,2870.346Zm-4.15-6.351h-.005a1.251,1.251,0,0,1-1.215-.962l-2.054-8.69a1.289,1.289,0,0,1-.1-.268l-5.016-21.368-4.026-17.038h-10.4a1.25,1.25,0,1,1,0-2.5h11.388a1.252,1.252,0,0,1,1.22.964l2.087,8.83h62.807a1.248,1.248,0,0,1,1.219,1.538l-6.962,29.573a1.251,1.251,0,0,1-1.218.963H293.025l1.526,6.458h44.68a1.25,1.25,0,1,1,0,2.5Zm-1.129-11.458h47.861l6.368-27.057H286.039Zm47.885-31.418a1.25,1.25,0,0,1-1.25-1.25V2804.5H316.156v5.449a1.25,1.25,0,0,1-2.5,0v-6.7a1.249,1.249,0,0,1,1.25-1.249h25.419a1.247,1.247,0,0,1,1.249,1.249v16.619a1.249,1.249,0,0,1-1.249,1.25Zm-13.782-1.25v-4.17H296.131v4.17a1.25,1.25,0,0,1-2.5,0v-5.42a1.251,1.251,0,0,1,1.25-1.251h32.906a1.251,1.251,0,0,1,1.25,1.251v5.42a1.25,1.25,0,1,1-2.5,0Z",
    fill: "#82decf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorSmartObject6);
export default __webpack_public_path__ + "static/media/Vector Smart Object (6).baa1ed9501a47fb0410a6403e8111bf8.svg";
export { ForwardRef as ReactComponent };